import { jsx as _jsx } from "react/jsx-runtime";
import { Profile } from '@web/components/Profile';
import { Page } from '@web/pages/layout/Page';
import { usePageTitle } from '@web/utility/hooks/usePageTitle';
export var ProfileView = function () {
    usePageTitle('Profile');
    return (_jsx(Page, { children: _jsx(Profile, {}) }));
};
